import {selectRandom, spine} from "p3";
import definitions from "../../../definitions";
import PlayerIvandoe from "./PlayerIvandoe";
import Player from "./Player";

export default class PlayerBert extends Player {
    constructor() {
        super();

        this.moveSpeed = 3500;
        this.collisionEnabled = false;

        this._idleAnimations = [
            "idle_00",
            "idle_01",
            "idle_02"
        ];

        this._walkAnimations = [
            "fly_u_standard_00",
            "fly_d_standard_00",
            "fly_r_standard_00",
        ];

        this._isIdleAnimation = false;
        this._isWalkAnimation = false;

        this._walkAnimationDir = definitions.ACTOR_ANIMATION_DIR.NONE;
        this._walkAnimationMaxSpeed = 240;
        this._walkAnimationTime = 0;
    }

    init() {
        super.init();

        this.addViewWithSpine(spine("char_bert"));

        this._view.y = -100;
        this._view.stateData.defaultMix = 0.1;
        this._view.scale.set(0.32);

        this.addShadow(definitions.SHADOW_SIZE.SMALL, 0.6);

        this.playIdleAnimation();
    }

    update() {
        super.update();

        if (this.moveToTarget instanceof PlayerIvandoe) {
            const ivandoe = this.moveToTarget;
            this.moveToTargetOffset.x = 100 * -ivandoe.facingDirection;
        }

        let animateRateScalar = 1;
        if (this._isWalkAnimation) {
            const speed = this.velocity.length;
            animateRateScalar = Math.max(1, speed / this._walkAnimationMaxSpeed);
        }

        (this.isMoving && !this._isIdleAnimation) && this.playWalkAnimation();

        this._view.update(window.dt * animateRateScalar);
        this._walkAnimationTime = this._view.state.tracks[0].trackTime;
    }

    playIdleAnimation() {
        this.playAnimation(selectRandom(this._idleAnimations));
    }

    playWalkAnimation() {
        const dir = this.velocity.unit();
        const lastWalkingDir = this._walkAnimationDir;

        if (dir.dot(new P3.Vector2(0, -1)) > 0.5) {
            this._walkAnimationDir = definitions.ACTOR_ANIMATION_DIR.UP;
        } else if (dir.dot(new P3.Vector2(0, 1)) > 0.5) {
            this._walkAnimationDir = definitions.ACTOR_ANIMATION_DIR.DOWN;
        } else {
            if (dir.x < 0) {
                this._walkAnimationDir = definitions.ACTOR_ANIMATION_DIR.LEFT;
            } else if (dir.x >= 0) {
                this._walkAnimationDir = definitions.ACTOR_ANIMATION_DIR.RIGHT;
            }
        }

        if (this._walkAnimationDir !== lastWalkingDir) {
            let animationName;
            switch (this._walkAnimationDir) {
                case definitions.ACTOR_ANIMATION_DIR.UP: {
                    animationName = "fly_u_standard_00";
                    break;
                }
                case definitions.ACTOR_ANIMATION_DIR.DOWN: {
                    animationName = "fly_d_standard_00";
                    break;
                }
                case definitions.ACTOR_ANIMATION_DIR.LEFT: {
                    animationName = "fly_r_standard_00";
                    break;
                }
                case definitions.ACTOR_ANIMATION_DIR.RIGHT: {
                    animationName = "fly_r_standard_00";
                    break;
                }
            }

            if (animationName) {
                this.playAnimation(animationName, true);
                this._view.state.tracks[0].trackTime = this._walkAnimationTime;
            }
        }
    }

    onMoveStop() {
        this._walkAnimationDir = definitions.ACTOR_ANIMATION_DIR.NONE;
        this._walkAnimationTime = 0;
    }

    /**
     * @param {string} name
     * @param entry
     */
    onAnimationStart(name, entry) {
        this._isIdleAnimation = this._idleAnimations.indexOf(name) >= 0;
        this._isWalkAnimation = this._walkAnimations.indexOf(name) >= 0;
    }

    /**
     * @param {string} name
     * @param entry
     */
    onAnimationComplete(name, entry) {
        if (this._idleAnimations.indexOf(name) >= 0) {
            this._isIdleAnimation = false;
            !this.isMoving && this.playIdleAnimation();
        }

        if (this._walkAnimations.indexOf(name) >= 0) {
            !this.isMoving && this.playIdleAnimation();
        }
    }
}